import React, {useEffect} from 'react';
import './howItWorksSectionStyle.scss';
import OrderHeadSectionComponent from "../../components/headSection/components/OrderHeadSectionComponent";
import ContactSectionComponent from "../../pages/main/sections/contactSection/ContactSectionComponent";
import { useTranslation } from "react-i18next";

const HowItWorksSectionComponent = () => {
	const { t } = useTranslation();

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	return (
		<div className="howItWorksSectionComponent__container">
			<div className="mainSectionComponent__container-content-overlay"></div>
			<OrderHeadSectionComponent />

			<div className="howItWorksSectionComponent__container-content">
				<div className="howItWorksSectionComponent__container-content-title">
					<h1>{t('navbar.howItWorks')}</h1>
				</div>
				<div className="howItWorksSectionComponent__container-content-data-wrap">
					<div className="howItWorksSectionComponent__container-content-main-image">
						<img src={`${process.env.PUBLIC_URL}/images/how-it-works-main.webp`} alt="how it works image" />
					</div>
					<div className="howItWorksSectionComponent__container-content-data">
						<div className="howItWorksSectionComponent__container-content-data-item first">
							<div className="howItWorksSectionComponent__container-content-data-item-text-wrap">
								<div className="howItWorksSectionComponent__container-content-data-title-wrap">
									<div className="howItWorksSectionComponent__container-content-data-item-number">
										<span>01</span>
									</div>
									<div className="howItWorksSectionComponent__container-content-data-item-title">
										<span>{t('howItWorks.discoverYourNextMeal')}</span>
									</div>
								</div>
								<div className="howItWorksSectionComponent__container-content-data-item-description">
									<span>{t('howItWorks.exploreSelectionTakeOutDineIn')}</span>
								</div>
							</div>
							<div className="howItWorksSectionComponent__container-content-data-item-image-wrap">
								<div className="howItWorksSectionComponent__container-content-data-item-image">
									<img src={`${process.env.PUBLIC_URL}/images/how-it-works-1.png`}
									     alt="how it works 1 image"/>
								</div>
							</div>
						</div>
						<div className="howItWorksSectionComponent__container-content-data-item second">
							<div className="howItWorksSectionComponent__container-content-data-item-text-wrap">
								<div className="howItWorksSectionComponent__container-content-data-title-wrap">
									<div className="howItWorksSectionComponent__container-content-data-item-number">
										<span>02</span>
									</div>
									<div className="howItWorksSectionComponent__container-content-data-item-title">
										<span>{t('howItWorks.transferQRCode')}</span>
									</div>
								</div>
								<div className="howItWorksSectionComponent__container-content-data-item-description">
									<span>{t('howItWorks.usePhoneCameraScan')}</span>
								</div>
							</div>
							<div className="howItWorksSectionComponent__container-content-data-item-image-wrap">
								<div
									className="howItWorksSectionComponent__container-content-data-item-image not-adaptive">
									<img src={`${process.env.PUBLIC_URL}/images/how-it-works-2.png`}
									     alt="how it works 2 image"/>
								</div>
								<div className="howItWorksSectionComponent__container-content-data-item-image adaptive">
									<img src={`${process.env.PUBLIC_URL}/images/how-it-works-2-adaptive.png`}
									     alt="how it works 2 image"/>
								</div>
							</div>
						</div>
						<div className="howItWorksSectionComponent__container-content-data-item third">
							<div className="howItWorksSectionComponent__container-content-data-item-text-wrap">
								<div className="howItWorksSectionComponent__container-content-data-title-wrap">
									<div className="howItWorksSectionComponent__container-content-data-item-number">
										<span>03</span>
									</div>
									<div className="howItWorksSectionComponent__container-content-data-item-title">
										<span>{t('howItWorks.showQRCodeToRestaurant')}</span>
									</div>
								</div>
								<div className="howItWorksSectionComponent__container-content-data-item-description">
									<span>{t('howItWorks.collectYourFoodDineIn')}</span>
								</div>
							</div>
							<div className="howItWorksSectionComponent__container-content-data-item-image-wrap">
								<div className="howItWorksSectionComponent__container-content-data-item-image">
									<img src={`${process.env.PUBLIC_URL}/images/how-it-works-3.png`}
								         alt="how it works 3 image"/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<ContactSectionComponent/>
		</div>
	);
};

export default HowItWorksSectionComponent;